import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '/backend/api';

const carData = {
  'swift-dzire': {
    name: 'Swift Dzire',
    title: 'Swift Dzire Rental',
    description: 'The Maruti Swift Dzire is the perfect choice for city travel and personal commute. With its exceptional fuel efficiency, comfortable interiors, and reliable performance, it\'s the ideal sedan for everyday use and short trips within the city.',
    image: '/assets/img/car/dzire.png',
    features: [
      'Comfortable seating for 4-5 passengers',
      'Excellent fuel efficiency',
      'Air conditioning and power steering',
      'Modern safety features',
      'Spacious boot for luggage',
      'Well-maintained and regularly serviced'
    ],
    specs: {
      transmission: 'Manual/Automatic',
      engine: '1.2L Petrol',
      fuelType: 'Petrol',
      seating: '5 Persons',
      mileage: '18-20 KMPL',
      bootSpace: '268 Liters'
    },
    pricing: [
      { type: 'Hourly', price: '₹400', unit: '/hour', note: '4 hours minimum' },
      { type: 'Half Day', price: '₹1,500', unit: '', note: '4-8 hours' },
      { type: 'Full Day', price: '₹2,500', unit: '', note: '8-12 hours' },
      { type: 'Monthly', price: '₹45,000', unit: '', note: '30 days' }
    ]
  },
  'maruti-ertiga': {
    name: 'Maruti Ertiga',
    title: 'Maruti Ertiga Rental',
    description: 'The Maruti Ertiga is the ideal choice for family trips and group travel. With its spacious interiors, comfortable seating for 7, and reliable performance, it\'s perfect for short weekend getaways or family outings. Features include large windows for scenic views and excellent fuel efficiency.',
    image: '/assets/img/car/ertiga.png',
    features: [
      'Spacious seating for 7 passengers',
      'Large windows for scenic views',
      'Air conditioning and power steering',
      'Advanced safety features',
      'Good ground clearance',
      'Regular maintenance and inspections'
    ],
    specs: {
      transmission: 'Manual/Automatic',
      engine: '1.5L Petrol',
      fuelType: 'Petrol',
      seating: '7 Persons',
      mileage: '16-18 KMPL',
      bootSpace: '209 Liters'
    },
    pricing: [
      { type: 'Hourly', price: '₹550', unit: '/hour', note: '4 hours minimum' },
      { type: 'Half Day', price: '₹2,000', unit: '', note: '4-8 hours' },
      { type: 'Full Day', price: '₹3,500', unit: '', note: '8-12 hours' },
      { type: 'Monthly', price: '₹60,000', unit: '', note: '30 days' }
    ]
  },
  'innova-crysta': {
    name: 'Innova Crysta',
    title: 'Innova Crysta Rental',
    description: 'The Toyota Innova Crysta is the ultimate choice for luxury and comfort. With its premium interiors, advanced features, and exceptional reliability, it\'s perfect for outstation trips and long-distance journeys. Enjoy the perfect blend of luxury and functionality.',
    image: '/assets/img/car/crysta.png',
    features: [
      'Premium seating for 8 passengers',
      'Luxury interiors and wood trim',
      'Advanced climate control',
      'Superior safety features',
      'Excellent ground clearance',
      'Premium entertainment system'
    ],
    specs: {
      transmission: 'Manual/Automatic',
      engine: '2.4L Petrol / 2.8L Diesel',
      fuelType: 'Petrol/Diesel',
      seating: '8 Persons',
      mileage: '14-16 KMPL',
      bootSpace: '300 Liters'
    },
    pricing: [
      { type: 'Hourly', price: '₹800', unit: '/hour', note: '4 hours minimum' },
      { type: 'Half Day', price: '₹2,800', unit: '', note: '4-8 hours' },
      { type: 'Full Day', price: '₹5,000', unit: '', note: '8-12 hours' },
      { type: 'Monthly', price: '₹85,000', unit: '', note: '30 days' }
    ]
  },
  'force-urbania': {
    name: 'Force Urbania',
    title: 'Force Urbania Rental',
    description: 'The Force Urbania is perfect for group travel and outstation trips. With seating for up to 13 passengers, spacious interiors, and excellent comfort features, it\'s the ideal choice for corporate trips, wedding parties, and group tours.',
    image: '/assets/img/car/arban.jpg',
    features: [
      'Spacious seating for 13 passengers',
      'Ample luggage space',
      'Climate control and comfort',
      'Modern safety features',
      'Professional trained drivers',
      'Regular maintenance checks'
    ],
    specs: {
      transmission: 'Manual',
      engine: '2.6L Diesel',
      fuelType: 'Diesel',
      seating: '13 Persons',
      mileage: '12-14 KMPL',
      bootSpace: '400 Liters'
    },
    pricing: [
      { type: 'Hourly', price: '₹1,000', unit: '/hour', note: '4 hours minimum' },
      { type: 'Half Day', price: '₹3,500', unit: '', note: '4-8 hours' },
      { type: 'Full Day', price: '₹6,500', unit: '', note: '8-12 hours' },
      { type: 'Monthly', price: '₹1,10,000', unit: '', note: '30 days' }
    ]
  },
  'tempo-traveller': {
    name: 'Tempo Traveller',
    title: 'Tempo Traveller Rental',
    description: 'The Tempo Traveller is the perfect vehicle for large group travel. With seating for up to 17 passengers, it offers comfortable and spacious interiors ideal for pilgrimages, group tours, and corporate outings.',
    image: '/assets/img/car/traveller.png',
    features: [
      'Spacious seating for 17 passengers',
      'Push-back reclining seats',
      'Air conditioning throughout',
      'Ample luggage space',
      'Entertainment system',
      'Professional experienced drivers'
    ],
    specs: {
      transmission: 'Manual',
      engine: '2.6L Diesel',
      fuelType: 'Diesel',
      seating: '17 Persons',
      mileage: '10-12 KMPL',
      bootSpace: 'Large'
    },
    pricing: [
      { type: 'Hourly', price: '₹900', unit: '/hour', note: '4 hours minimum' },
      { type: 'Half Day', price: '₹3,000', unit: '', note: '4-8 hours' },
      { type: 'Full Day', price: '₹5,500', unit: '', note: '8-12 hours' },
      { type: 'Monthly', price: '₹95,000', unit: '', note: '30 days' }
    ]
  },
  'bus-56seater': {
    name: '56-Seater Bus',
    title: '56-Seater Bus Rental',
    description: 'Our 56-Seater Bus is the ultimate solution for large group transportation. Perfect for corporate events, school trips, wedding parties, and large group tours. Equipped with modern amenities for a comfortable journey.',
    image: '/assets/img/car/bus.png',
    features: [
      'Spacious seating for 56 passengers',
      'Air conditioning throughout',
      'Comfortable push-back seats',
      'Large luggage compartment',
      'Entertainment system',
      'Professional experienced drivers'
    ],
    specs: {
      transmission: 'Manual',
      engine: '5.9L Diesel',
      fuelType: 'Diesel',
      seating: '56 Persons',
      mileage: '6-8 KMPL',
      bootSpace: 'Extra Large'
    },
    pricing: [
      { type: 'Hourly', price: '₹2,000', unit: '/hour', note: '4 hours minimum' },
      { type: 'Half Day', price: '₹6,000', unit: '', note: '4-8 hours' },
      { type: 'Full Day', price: '₹12,000', unit: '', note: '8-12 hours' },
      { type: 'Monthly', price: '₹2,50,000', unit: '', note: '30 days' }
    ]
  }
};

// Inquiry Form Component
const InquiryForm = ({ car }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch(`${API_BASE}/car-inquiry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          car_model: car.name,
          car_id: null,
          message: formData.message
        })
      });

      const data = await response.json();

      if (data.status) {
        setSubmitStatus({ type: 'success', message: data.message });
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setSubmitStatus({ type: 'error', message: data.message });
      }
    } catch (err) {
      console.error('Error submitting inquiry:', err);
      setSubmitStatus({ type: 'error', message: 'Failed to submit inquiry. Please try again.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="inquiry-form-section" style={{
      padding: '60px 0',
      background: '#fff'
    }}>
      <div className="themesflat-container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-12">
            <div className="heading-section text-center mb-40">
              <h2 className="title">Enquire About {car.name}</h2>
              <p className="description">Fill in the form below and we will get back to you shortly</p>
            </div>
            
            <form onSubmit={handleSubmit} style={{
              background: '#f8f9fa',
              padding: '40px',
              borderRadius: '10px',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
              <div className="row">
                <div className="col-lg-6 col-md-6 mb-20">
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Your Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '14px'
                    }}
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-20">
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your email"
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '14px'
                    }}
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-20">
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Enter your phone number"
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '14px'
                    }}
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-20">
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Car Model
                  </label>
                  <input
                    type="text"
                    value={car.name}
                    readOnly
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '14px',
                      background: '#eee',
                      color: '#666'
                    }}
                  />
                </div>
                <div className="col-lg-12 mb-20">
                  <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                    Your Message *
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    placeholder="Enter your message"
                    rows="4"
                    style={{
                      width: '100%',
                      padding: '12px 15px',
                      border: '1px solid #ddd',
                      borderRadius: '5px',
                      fontSize: '14px',
                      resize: 'vertical'
                    }}
                  ></textarea>
                </div>
                <div className="col-lg-12 text-center">
                  <button
                    type="submit"
                    disabled={submitting}
                    className="button_main_inner"
                    style={{
                      padding: '15px 40px',
                      fontSize: '16px',
                      cursor: submitting ? 'not-allowed' : 'pointer',
                      opacity: submitting ? 0.7 : 1
                    }}
                  >
                    {submitting ? 'Submitting...' : 'Submit Inquiry'}
                  </button>
                </div>
              </div>

              {submitStatus && (
                <div style={{
                  marginTop: '20px',
                  padding: '15px',
                  borderRadius: '5px',
                  background: submitStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                  color: submitStatus.type === 'success' ? '#155724' : '#721c24',
                  textAlign: 'center'
                }}>
                  {submitStatus.message}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const CarDetail = () => {
  const { carSlug } = useParams();
  const car = carData[carSlug];

  if (!car) {
    return (
      <div className="main-content" style={{ padding: '200px 0', textAlign: 'center' }}>
        <h2>Car not found</h2>
        <Link to="/">Go back to Home</Link>
      </div>
    );
  }

  return (
    <div className="main-content">
      {/* SEO Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": `${car.name} Rental - Cab Experience`,
          "description": car.description,
          "image": [car.image],
          "brand": {
            "@type": "Brand",
            "name": "Cab Experience"
          },
          "offers": {
            "@type": "Offer",
            "category": "Car Rental Service",
            "areaServed": {
              "@type": "Place",
              "name": "Rajkot, Gujarat, India"
            }
          }
        })
      }} />

      {/* Breadcrumb Schema */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://cabexperience.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Our Cars",
              "item": "https://cabexperience.com/car-list"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": car.name,
              "item": `https://cabexperience.com/${carSlug}`
            }
          ]
        })
      }} />

      {/* Page Title */}
      <section
        className="page-title"
        style={{
          backgroundImage: 'url("/assets/images/bg1.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '100px 0'
        }}
      >
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-title-inner">
                <h1 className="title" style={{ color: 'white', textShadow: '0 2px 10px rgba(0,0,0,0.5)', fontSize: '2.5rem' }}>
                  {car.name} Rental in Rajkot
                </h1>
                <nav aria-label="breadcrumb" className="breadcrumb" style={{ color: 'white', marginTop: '15px' }}>
                  <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                    <li><Link to="/" style={{ color: 'white', textDecoration: 'none' }}>Home</Link></li>
                    <li><span style={{ opacity: 0.7 }}>/</span></li>
                    <li><Link to="/car-list" style={{ color: 'white', textDecoration: 'none' }}>Our Cars</Link></li>
                    <li><span style={{ opacity: 0.7 }}>/</span></li>
                    <li style={{ opacity: 0.9 }}>{car.name}</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Car Details */}
      <section style={{ padding: '80px 0' }}>
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="car-image">
                <img
                  src={car.image}
                  alt={`${car.name} - Cab Experience Car Rental Rajkot`}
                  title={`${car.name} Rental Service in Rajkot - Cab Experience`}
                  style={{ width: '100%', borderRadius: '10px' }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="car-content">
                <h2 className="title mb-20" style={{ fontSize: '1.8rem' }}>{car.title} in Rajkot</h2>
                <p className="description mb-20" style={{ lineHeight: '1.8' }}>{car.description}</p>

                <h3 className="mb-15" style={{ fontSize: '1.3rem' }}>Key Features:</h3>
                <div className="list-icon-check mb-30">
                  <ul>
                    {car.features.map((feature, index) => (
                      <li key={index}>
                        <i className="icon-Vector-32" style={{ color: '#edb808' }}></i>
                        <p>{feature}</p>
                      </li>
                    ))}
                  </ul>
                </div>

                <h3 className="mb-15" style={{ fontSize: '1.3rem' }}>Specifications:</h3>
                <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
                  <p><strong>Transmission:</strong> {car.specs.transmission}</p>
                  <p><strong>Engine:</strong> {car.specs.engine}</p>
                  <p><strong>Fuel Type:</strong> {car.specs.fuelType}</p>
                  <p><strong>Seating Capacity:</strong> {car.specs.seating}</p>
                  <p><strong>Mileage:</strong> {car.specs.mileage}</p>
                  <p><strong>Boot Space:</strong> {car.specs.bootSpace}</p>
                </div>

                <div className="btn-main mt-30" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                  <Link to="/book-a-car" className="button_main_inner">
                    <span>Book Now</span>
                  </Link>
                  <Link to="/contact-us" className="button_main_inner" style={{ background: '#333' }}>
                    <span>Get Quote</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Cars Section */}
      <section style={{ padding: '60px 0', background: '#f8f9fa' }}>
        <div className="themesflat-container">
          <div className="heading-section text-center mb-40">
            <h2 className="title" style={{ fontSize: '2rem' }}>Related Car Rentals</h2>
            <p className="description">Explore more car options for your journey</p>
          </div>
          <div className="row">
            {Object.entries(carData)
              .filter(([slug]) => slug !== carSlug)
              .slice(0, 3)
              .map(([slug, relatedCar]) => (
                <div key={slug} className="col-lg-4 col-md-6 mb-20">
                  <Link to={`/${slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div style={{ 
                      background: '#fff', 
                      borderRadius: '10px', 
                      overflow: 'hidden',
                      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                      <img 
                        src={relatedCar.image} 
                        alt={relatedCar.name}
                        style={{ width: '100%', height: '200px', objectFit: 'contain', padding: '20px' }}
                      />
                      <div style={{ padding: '20px', textAlign: 'center' }}>
                        <h4 style={{ margin: '0 0 10px', color: '#333' }}>{relatedCar.name}</h4>
                        <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>{relatedCar.specs.seating}</p>
                        <span style={{ display: 'inline-block', marginTop: '10px', color: '#edb808', fontWeight: '500' }}>
                          View Details →
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* SEO Content Section */}
      <section style={{ padding: '60px 0' }}>
        <div className="themesflat-container">
          <div className="row">
            <div className="col-lg-12">
              <div style={{ maxWidth: '800px', marginInline: 'auto' }}>
                <h2 style={{ fontSize: '1.8rem', marginBottom: '20px', textAlign: 'center' }}>
                  Why Choose {car.name} from Cab Experience?
                </h2>
                <div style={{ lineHeight: '1.8', color: '#555' }}>
                  <p style={{ marginBottom: '15px' }}>
                    Looking for reliable <strong>{car.name} rental in Rajkot</strong>? Cab Experience offers premium car rental services 
                    with professional drivers, well-maintained vehicles, and competitive pricing. Our {car.name} is perfect for 
                    {car.name.toLowerCase().includes('bus') ? 'large group transportation' : car.specs.seating.includes('7') || car.specs.seating.includes('8') ? 'family trips and group travel' : 'city travel and personal commute'}.
                  </p>
                  <p style={{ marginBottom: '15px' }}>
                    <strong>Service Areas:</strong> Rajkot, Gujarat | Ahmedabad | Surat | Vadodara | Jamnagar | Junagadh | 
                    Bhavnagar | Gandhinagar | Morbi | Porbandar | Veraval | Dwarka | Somnath | Kutch
                  </p>
                  <p style={{ marginBottom: '15px' }}>
                    <strong>Occasions:</strong> Airport Transfer | City Tour | Wedding Functions | Corporate Events | 
                    Pilgrimage Tours | Weekend Getaways | Educational Trips | Family Functions
                  </p>
                  <div style={{ 
                    background: '#f8f9fa', 
                    padding: '20px', 
                    borderRadius: '8px', 
                    marginTop: '20px',
                    borderLeft: '4px solid #edb808'
                  }}>
                    <h4 style={{ margin: '0 0 10px' }}>Contact Us for {car.name} Rental</h4>
                    <p style={{ margin: 0 }}>
                      📞 <strong>Phone:</strong> +91 7801904444<br />
                      📧 <strong>Email:</strong> info@cabexperience.com<br />
                      📍 <strong>Address:</strong> Rajkot, Gujarat, India
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CarDetail;
